import Vue from 'vue';
import { VideoVisibility } from '@lumiere/db/types';
import ViewerVideo from './ViewerVideo.vue';
import { mapState, mapGetters } from 'vuex';
import ACTION from '../store/ACTION';
import ViewerLoading from '@/components/ViewerLoading.vue';
import ChannelVideosWrapper from '@/components/ChannelVideosWrapper.vue';
import ChannelVideoTag from '@/components/ChannelVideoTag.vue';
import { SPACEBAR_KEYCODE, SPACEBAR_KEY } from '@lumiere/shared/utils/constants';
import Linkify from '@/components/Linkify.vue';
export default Vue.extend({
    name: 'ViewerChannelVideo',
    props: {
        channel: {
            type: Object,
        },
        vid: String,
        channelVideos: {
            type: Array,
        },
    },
    data() {
        return {
            videoData: null,
        };
    },
    async serverPrefetch() {
        return this.fetchVideo();
    },
    mounted() {
        if (this.vid) {
            this.fetchVideo();
        }
        // prevent page scrolling on spacebar pressed
        window.addEventListener('keydown', this.onkeydownPressed);
    },
    computed: {
        ...mapState(['video']),
        ...mapGetters(['channelTags']),
        isPrivateVideo() {
            return this.videoData?.visibility === VideoVisibility.Private;
        },
        otherChannelVideos() {
            return this.channelVideos.filter((v) => v.id !== this.vid);
        },
        // I think there's a channelVideoTags field on channel which is not yet implemented yet.
        // for now, I'll just return the channelTags corresponding to the video workspace tags
        channelVideoTags() {
            return this.channelTags.filter((tag) => (this.videoData?.tags ?? []).includes(tag.id));
        },
    },
    methods: {
        async fetchVideo() {
            await this.$store.dispatch(ACTION.FETCH_VIDEO, {
                vid: this.vid,
                cid: this.channel.id,
            });
        },
        onkeydownPressed(e) {
            if ((e.key == SPACEBAR_KEY || e.keyCode == SPACEBAR_KEYCODE) &&
                e.target == document.body) {
                e.preventDefault();
            }
        },
    },
    watch: {
        video(_video) {
            if (_video?.video) {
                this.videoData = _video.video;
            }
        },
        videoData: {
            handler(data) {
                if (data) {
                    this.$nextTick(() => {
                        const container = this.$refs.channelVideo;
                        if (container?.ownerDocument?.defaultView) {
                            let top = container.getBoundingClientRect().top;
                            let offset = container.ownerDocument.defaultView.pageYOffset;
                            window.scrollTo({
                                top: top + offset,
                                behavior: 'smooth',
                            });
                        }
                    });
                }
            },
            immediate: true,
            deep: true,
        },
    },
    beforeRouteEnter(_to, _from, next) {
        next((vm) => {
            const vid = vm.$props.vid;
            const channelVideos = vm.$props.channelVideos;
            const hasVideo = channelVideos.find((video) => video.id === vid);
            if (!hasVideo) {
                next(`/c/${vm.$route.params.cid}`);
            }
            else {
                next();
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.onkeydownPressed);
    },
    components: {
        ViewerVideo,
        ViewerLoading,
        ChannelVideosWrapper,
        ChannelVideoTag,
        Linkify
    },
});
